import { motion } from "framer-motion";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

// Smooth fade-in transitions to prevent layout shifts
const variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: "easeOut",
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.15,
      ease: "easeIn",
    }
  },
};

// Rotas onde não queremos qualquer fade de entrada (evita ver a página
// anterior por trás durante a transição — ex.: flash no login mobile).
const NO_FADE_ROUTES = ["/auth"];

export default function PageTransition({ children }: { children: ReactNode }) {
  const isNative = Capacitor.isNativePlatform();
  const location = useLocation();
  const skipFade = NO_FADE_ROUTES.some((p) => location.pathname.startsWith(p));

  // Disable animations on native platforms for instant transitions
  if (isNative || skipFade) {
    return (
      <div className="flex flex-col flex-1 w-full h-full bg-background">
        {children}
      </div>
    );
  }

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="flex flex-col flex-1 w-full h-full bg-background"
      style={{ willChange: "opacity" }}
    >
      {children}
    </motion.div>
  );
}
